import store from "@/store"
import { formatterDate } from "@/libs/utils"
export enum Operatore {
  Slant = "/",
  Horizontal = "-"
}

export const toLocalTime = (utcTimeString: string | Date, operator: Operatore = Operatore.Slant): string => {
  const dt = new Date(utcTimeString);
  const day = dt.getDate(),
    month = dt.getMonth() + 1,
    year = dt.getFullYear(),
    hours = dt.getHours(),
    minutes = dt.getMinutes(),
    seconds = dt.getSeconds();

  switch (operator) {
    case Operatore.Slant:
      return (pad((month)) + '/' + pad(day) + '/' + year + ' ' + pad(hours) + ':' + pad(minutes));
    case Operatore.Horizontal:
      return `${year}-${pad(month)}-${pad(day)} ${pad(hours)}:${pad(minutes)}`;
  }
}

const pad = (number: number) => {
  if (number < 10)
    return `0${number}`;
  return number;
}

export const generateGUID = () => {
  function S4() {
    return (((1 + Math.random()) * 8 * 1000) | 0).toString(16)
  }
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}

export const utf16toEntities = (str: string | null) => {
  var patt = /[\ud800-\udbff][\udc00-\udfff]/g; // 检测utf16字符正则
  if (str) {
    str = str.replace(patt, function (char) {
      var H, L, code;
      if (char.length === 2) {
        H = char.charCodeAt(0); // 取出高位
        L = char.charCodeAt(1); // 取出低位
        code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
        return "&#" + code + ";";
      } else {
        return char;
      }
    });
  }
  return str;
}

export const uncodeUtf16 = (str: string | null) => {
  var reg = /\&#.*?;/g;
  if (str) {
    var result = str.replace(reg, function (char: any) {
      var H, L, code;
      if (char.length == 9) {
        code = parseInt(char.match(/[0-9]+/g));
        H = Math.floor((code - 0x10000) / 0x400) + 0xd800;
        L = ((code - 0x10000) % 0x400) + 0xdc00;
        return unescape("%u" + H.toString(16) + "%u" + L.toString(16));
      } else {
        return char;
      }
    });
    return result;
  }
  return "";
}
